<template>
    <div class="pop-up-wrap" :style="{visibility:popFlag?'':'hidden'}">
        <div class="pop-up-title">
            <span>陆港通异动回测</span>
            <div class="pop-up-close fr" @click="closePop">
                <a-icon type="close" />
            </div>
        </div>
        <!-- <GeminiScrollbar> -->
        <div class="pop-up-container">
            <div class="capital-analysis">
                <div class="capital-analysis-title">分析参考</div>
                <div class="capital-analysis-cont">{{popData.split('-')[0]}}年，北向资金大幅异动共发生{{times}}次，点击下列日期查看详细走势。</div>
            </div>
            <ul class="pop-up-dates clearfix" v-if="dateList.length">
                <li v-for="(item, index) in dateList"
                    :key="index"
                    class="pop-up-dates-item fl"
                    :class="dateList[index]===popData?'pop-up-dates-item-active':''"
                    @click="checkDate(index)">{{item}}
                </li>
            </ul>
            <div class="pop-up-chart-wrap">
                <div class="pop-up-chart" id="pop-up-chart"></div>
                <div class="k-line-tol poa">
                    <span>上证指数</span>
                    <span class="open" v-if="open">开:
                        <span :class="open>yc?'up':'down'">{{open}}</span>
                    </span>
                    <span class="close" v-if="close">收:
                        <span :class="close>yc?'up':'down'">{{close}}</span>
                    </span>
                </div>
                <div class="cjl-tol poa" v-if="cjl">
                    成交额: <span>{{cjl}}</span>
                </div>
                <div class="zjlr-tol poa">
                    陆港通资金流入：<span>{{zjlr}}</span>
                </div>
            </div>
        </div> 
        <!-- </GeminiScrollbar> -->
    </div>
</template>

<script>
import { getHistory } from '../assets/js/action'
export default {
    data() {
        return {
            popFlag: false,
            popData: '',
            times: 1,
            dateList: [],
            lrData: {},
            open: '',
            close: '',
            cjl: '',
            zjlr: '',
            yc: ''
        }
    },
    mounted() {
        this.getHistoryData()
        window.addEventListener('click', (e) => {
            if (e.target.classList.contains('fund-mark-point')) {
                this.popFlag = true
                this.popData = e.target.getAttribute('popData')
                let year = this.popData.substring(0, 4)
                this.dateList = []
                this.lrData.map.map((item) => {
                    if (item.date.indexOf(year) !== -1) {
                        this.dateList.push(item.date)
                    }
                })
                this.times = this.dateList.length
                this.initChart()
                // 点击埋点
                let value = e.target.getAttribute('valData')
                let inStat = value > 0 ? 'flowin' : 'flowout'
                window.TA.log({
                    id: `webhsgt_bxls_${inStat}_click`
                })
            }
        })
    },
    methods: {
        closePop() {
            this.popFlag = false
        },
        checkDate(index) {
            this.popData = this.dateList[index]
            this.initChart()
            window.TA.log({
                id: `webhsgt_history_dateselect`
            })
        },
        getHistoryData: function() {
            getHistory('north', 'day').then(d => {
                this.lrData = d.data.data.zhuri
            })
        },
        formatterTooltip(num, byte, unit) {
            if(unit) {
                if(unit === '手') {
                    if (num / 1e8 > 1) {
                        num = (num / 1e8).toFixed(byte) + '亿' + unit
                    } else if (num / 1e4 > 1) {
                        num = (num / 1e4).toFixed(byte) + '万' + unit
                    } else {
                        num  = (num / 1).toFixed(byte) + unit
                    }
                } else {
                    num = (num*1).toFixed(byte) + unit
                }
            } else {
                if (num / 1e8 > 1 || num / 1e8 < -1) {
                    num = (num / 1e8).toFixed(byte) + '亿'
                } else if (num / 1e4 > 1 || num / 1e4 < -1) {
                    num = (num / 1e4).toFixed(byte) + '万'
                } else {
                    num  = (num / 1).toFixed(byte)
                }
            }
            return num
        },
        initChart() {
            let el = document.getElementById('pop-up-chart')
            // 获取资金流向数据
            let dateIndex = this.lrData.date.indexOf(this.popData)
            let date = this.lrData.date.slice(dateIndex - 40, dateIndex + 40) // 横坐标数据
            let lrCol = this.lrData.total.slice(dateIndex - 40, dateIndex + 40) // 北向资金纵坐标
            if (date.length === 0) {
                return 
            } 
            let popChart = window.echarts.init(el)
            // 获取上证指数数据
            // let startDate = date[0].replace(/-/ig, '')
            // let endDate = date[date.length - 1].replace(/-/ig, '')
            let kLineLast = {
                type: 'klineLast',
                code: 'hs_1A0001',
                ma: [5, 10, 30],
                lastDays: 1500
            }
            let klineLastProvider = window.D3Charts.getDataPool().register(kLineLast)
            window.D3Charts.getDataPool().onAction(klineLastProvider, 'PROVIDER_UPDATE.myproject', (d) => {
                if (d.fetchStatus.code !== '000') return
                let hqData = d.data.dataArray
                // let startIndex, endIndex
                // hqData.map((item, index) => {
                //     if (item.t === startDate) {
                //         startIndex = index
                //     }
                //     if (item.t === endDate) {
                //         endIndex = index
                //     }
                // })
                // hqData = hqData.slice(startIndex, endIndex + 1)
                let kData = []
                let m05 = []
                let m10 = []
                let m30 = []
                let volumes = []
                let yc = []
                // hqData.map(item => {
                //     kData.push([
                //         item.o, // 开盘价
                //         item.c,// 收盘价
                //         item.i,// 最低价
                //         item.a,// 最高价
                //     ])
                //     yc.push(item.yc)
                //     m05.push(item.ma5)
                //     m10.push(item.ma10)
                //     m30.push(item.ma30)
                //     volumes.push(item.n)
                // })
                hqData.map(item => {
                    if (date.indexOf(item.t.replace(/^(\d{4})(\d{2})(\d{2})$/,  "$1-$2-$3")) !== -1) {
                        kData.push([
                            item.o, // 开盘价
                            item.c,// 收盘价
                            item.i,// 最低价
                            item.a,// 最高价
                        ])
                        yc.push(item.yc)
                        m05.push(item.ma5)
                        m10.push(item.ma10)
                        m30.push(item.ma30)
                        // volumes.push(item.n / 100)
                        volumes.push(item.np)
                    }
                })
                popChart.setOption({
                    legend: {
                        show: false
                    },
                    axisPointer: {
                        link: {xAxisIndex: 'all'}
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: (p) => {
                            let i = p[0].dataIndex
                            this.open = this.formatterTooltip(kData[i][0], 2)
                            this.close = this.formatterTooltip(kData[i][1], 2)
                            // this.cjl = this.formatterTooltip(volumes[i], 2, '手')
                            this.cjl = this.formatterTooltip(volumes[i], 0)
                            this.zjlr = lrCol[i] !== '--' ? this.formatterTooltip(lrCol[i], 2) : '--'
                            this.yc = yc[i]
                            return `<div>
                                <div>${p[0].axisValue}</div>
                                <div>开盘价:<span class="${this.open>this.yc?'up':'down'}">${this.open}</span></div>
                                <div>最高价:<span class="${kData[i][3]>this.yc?'up':'down'}">${this.formatterTooltip(kData[i][3], 2)}</span></div>
                                <div>最低价:<span class="${kData[i][2]>this.yc?'up':'down'}">${this.formatterTooltip(kData[i][2], 2)}</span></div>
                                <div>收盘价:<span class="${this.close>this.yc?'up':'down'}">${this.close}</span></div>
                            </div>`
                        },
                        position: ['80%', 100]
                    },
                    grid: [
                        {
                            height: '125px',
                            top: 28,
                            left: 50,
                            right: 8,
                            borderColor: '#343434',
                            containLabel: false,
                            show: true
                        }, 
                        {
                            height: '80px',
                            top: 175,
                            left: 50,
                            right: 8,
                            borderColor: '#343434',
                            containLabel: false,
                            show: true
                        }, 
                        {
                            height: '100px',
                            top: 280,
                            left: 50,
                            right: 8,
                            borderColor: '#343434',
                            containLabel: false,
                            show: true
                        }
                    ],
                    xAxis: [
                        {
                            gridIndex: 0,
                            type: 'category',
                            show: false,
                            data: date,
                            axisTick: { show: false },
                            axisPointer: {
                                label: {
                                    show: true,
                                    formatter: function(p) {
                                        return p.value
                                    },
                                    fontFamily: 'SimSun'
                                }
                            }
                        }, 
                        {
                            gridIndex: 1,
                            type: 'category',
                            show: false,
                            data: date,
                            axisTick: { show: false },
                            axisPointer: {
                                label: {
                                    show: true,
                                    formatter: function(p) {
                                        return p.value
                                    },
                                    fontFamily: 'SimSun'
                                }
                            }
                        }, 
                        {
                            gridIndex: 2,
                            type: 'category',
                            show: true,
                            data: date,
                            axisTick: { show: false },
                            axisPointer: {
                                label: {
                                    show: true,
                                    formatter: function(p) {
                                        return p.value
                                    },
                                    fontFamily: 'SimSun'
                                }
                            }
                        }
                    ],
                    yAxis: [
                        {
                            gridIndex: 0,
                            axisTick: { show: false },
                            axisLine: { show: false},
                            splitLine: { show: false },
                            axisLabel: {
                                color: '#aaaaaa',
                                fontSize: 12
                            },
                            min: function(v) {
                                return ~~v.min
                            }
                        }, {
                            gridIndex: 1,
                            axisTick: { show: false },
                            axisLine: { show: false},
                            splitLine: { show: false },
                            axisLabel: {
                                color: '#aaaaaa',
                                formatter: (value, index) => {
                                    if (index&1) {
                                        if (value/1e8>=1||value/1e8<=-1) {
                                            return value/1e8 + '亿'
                                        } else if (value/1e4>=1||value/1e4<=-1) {
                                            return value/1e4 + '万'
                                        } else {
                                            return value
                                        }
                                    }
                                },
                                fontSize: 12
                            }
                        }, {
                            gridIndex: 2,
                            axisTick: { show: false },
                            axisLine: { show: false},
                            splitLine: { show: false },
                            axisLabel: {
                                color: '#aaaaaa',
                                formatter: (value, index) => {
                                    if (index&1) {
                                        if (value/1e8>=1||value/1e8<=-1) {
                                            return value/1e8 + '亿'
                                        } else if (value/1e4>=1||value/1e4<=-1) {
                                            return value/1e4 + '万'
                                        } else {
                                            return value
                                        }
                                    }
                                },
                                fontSize: 12
                            }
                        }
                    ],
                    series: [
                        {
                            type: 'candlestick',
                            data: kData,
                            itemStyle: {
                                color: '#e9524d',
                                color0: '#279e64',
                                borderColor: null,
                                borderColor0: null
                            },
                            symbol: 'none',
                            markLine: {
                                symbol: 'none',
                                data: [{
                                    xAxis: this.popData,
                                    symbol: 'none'
                                }],
                                lineStyle: {
                                    type: 'dashed',
                                    color: '#000'
                                }
                            }
                        }, 
                        {
                            type: 'line',
                            data: m05,
                            symbol: 'none',
                            lineStyle: {
                                width: 1
                            }
                        }, 
                        {
                            type: 'line',
                            data: m10,
                            symbol: 'none',
                            lineStyle: {
                                width: 1                                
                            }
                        }, 
                        {
                            type: 'line',
                            data: m30,
                            symbol: 'none',
                            lineStyle: {
                                width: 1
                            }
                        }, 
                        {
                            name: '成交额',
                            type: 'bar',
                            data: volumes, 
                            xAxisIndex: 1,
                            yAxisIndex: 1,
                            symbol: 'none',
                            itemStyle: {
                                color: (p) => {
                                    let i = p.dataIndex
                                    return kData[i][0] > kData[i][1] ? '#279e64' : '#e9524d'
                                }
                            },
                            markLine: {
                                symbol: 'none',
                                data: [{
                                    xAxis: this.popData,
                                }],
                                lineStyle: {
                                    type: 'dashed',
                                    color: '#000'
                                }
                            }
                        }, 
                        {
                            name: '资金流入',
                            type: 'bar',
                            symbol: 'none',
                            data: lrCol,
                            xAxisIndex: 2,
                            yAxisIndex: 2,
                            itemStyle: {
                                color: function(d) {
                                    return d.value > 0 ? '#e9524d' : '#279e64'
                                }
                            },
                            markLine: {
                                symbol: 'none',
                                data: [{
                                    xAxis: this.popData
                                }],
                                lineStyle: {
                                    type: 'dashed',
                                    color: '#000'
                                }
                            }
                        }
                    ],
                })
            })
        }
    }
}
</script>

<style lang="less">
.pop-up-wrap {
    width: 844px;
    min-height: 590px;
    position: fixed;
    top: 20px;
    left: 50%;
    margin-left: -422px;
    background: #fafafa;
    z-index: 2;
    padding-bottom: 20px;
    .pop-up-title {
        height: 40px;
        line-height: 40px;
        padding: 0 17px 11px;
        background: #434343;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
        .pop-up-close {
            width: 12px;
            height: 40px;
        }
    }
    .pop-up-container {
        padding: 0 33px;
        .capital-analysis {
            height: 50px;
            line-height: 50px;
            display: flex;
            &-title {
                text-align: center;
                width: 112px;
                font-size: 18px;
                color: #464646;
            }
            .capital-analysis-cont {
                text-align: left;
                flex: 1;
                font-size: 12px;
                color: #707070;
            }
        }
        .pop-up-dates {

            &-item {
                width: 112px;
                box-sizing: border-box;
                height: 28px;
                border: 1px solid #b0b0b0;
                border-radius: 4px;
                line-height: 28px;
                text-align: center;
                color: #464646;
                margin: 0 8px 5px 0;
                &:last-child{
                    margin-right: 0;
                }
                &-active {
                    border: 1px solid #3e93e2;
                    color: #3e93e2;
                }
            }
        }
        .pop-up-chart-wrap {
            height: 410px;
            position: relative;
            .pop-up-chart {
                height: 410px;
                background: #eaeaee;
            }
            .k-line-tol {
                left: 50px;
                top: 10px;
                .open{ margin-left: 10px; } 
                .close{ margin-left: 10px; } 
            }
            .cjl-tol {
                left: 50px;
                top: 156px;
            }
            .zjlr-tol {
                left: 50px;
                top: 262px;
            }
        }
    }
}
</style>
